import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
const StyledTextarea = styled.textarea.withConfig({
  displayName: "AutoResizeTextarea__StyledTextarea",
  componentId: "sc-1xxsl4d-0"
})(["overflow:hidden;resize:none;"]);
export const AutoResizeTextarea = props => {
  const ref = useRef();

  const refresh = () => {
    const element = ref.current;
    if (!element) return; // Ignore scrollHeight of 0. This seems to only happen when it's invisible (e.g. because
    // a SlideMenu was closed) and in that case we don't care about changing the height.

    if (element.scrollHeight === 0) return; // If we are still at the same scrollHeight than we were after the last adjustment, ignore.

    if (element.scrollHeightAfterAdjusting === element.scrollHeight) return; // Method taken from: https://stackoverflow.com/questions/454202/creating-a-textarea-with-auto-resize
    // "OPTION 2 (Pure JavaScript)"
    // Set to auto first to get the right scrollHeight. If you remove this line, the text
    // field will slowly shrink every call if it's a one-liner.

    element.style.height = "auto";
    element.style.height = element.scrollHeight + "px";
    element.scrollHeightAfterAdjusting = element.scrollHeight;
  };

  useEffect(() => {
    refresh();
  }, [ref.current, props.value, props.placeholder]); // React to resize. This is necessary if the element can be hidden, e.g. in a SlideMenu.

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const resizeObserver = new ResizeObserver(refresh);
    resizeObserver.observe(element);
    return () => resizeObserver.unobserve(element);
  }, [ref.current]);
  return /*#__PURE__*/React.createElement(StyledTextarea, _extends({
    ref: ref
  }, props));
};
export const AutoResizeTextareaFullWidth = styled(AutoResizeTextarea).withConfig({
  displayName: "AutoResizeTextarea__AutoResizeTextareaFullWidth",
  componentId: "sc-1xxsl4d-1"
})(["width:100%;&.invalid{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}"], UiConstants.COLOR_VALUE_INVALID);